/**
 * What a `/flow/data-access` request is scoped to. Every endpoint on that surface takes an
 * `entityType`/`entityId` pair; which members it accepts is the endpoint's own business.
 */
export var FlowEntityType;
(function (FlowEntityType) {
    FlowEntityType["Encounter"] = "encounter";
    FlowEntityType["EhrInformation"] = "ehrInformation";
    FlowEntityType["PatientOrder"] = "patientOrder";
    FlowEntityType["ExternalDocumentPacket"] = "externalDocumentPacket";
})(FlowEntityType || (FlowEntityType = {}));
//# sourceMappingURL=entityType.js.map